import { render, staticRenderFns } from "./Apparel.vue?vue&type=template&id=bf17a898&scoped=true&"
import script from "./Apparel.vue?vue&type=script&lang=js&"
export * from "./Apparel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf17a898",
  null
  
)

export default component.exports